import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  return (
    <nav className="main-nav">
      <div className="nav-content">
        <NavLink 
          to="/" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          end
        >
          Movies
        </NavLink>
        <NavLink 
          to="/books" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          Books
        </NavLink>
      </div>
    </nav>
  );
}

export default Navigation; 